import { render } from "./QwilrDefinitionPage.vue?vue&type=template&id=b3399a30&ts=true"
import script from "./QwilrDefinitionPage.vue?vue&type=script&lang=ts"
export * from "./QwilrDefinitionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__